const ORDER_STATISTICS_TABLE_READY = "order-statistics-table-ready"

const SEARCH_TEXT_STATE = "order-statistics-table-search-text-state"
const ROWS_PER_PAGE_STATE = "order-statistics-table-rows-per-page-state"
const PAGINATION_STATE = "order-statistics-table-pagination-state"

const SLOT_NO_FILTER_STATE = "order-statistics-table-slot_no-filter-state"
const DATE_FILTER_STATE = "order-statistics-table-date-filter-state"

const PUSH_ORDER_STATISTICS_VALUE = "order-statistics-table-push-order-statistics-value"


const initialState = {
    isOrderStatisticsTableReady: true,
    orderStatistics:{},
    pushOrderStatisticsDetails:null,

    previousStartDateState: "",
    previousEndDateState: "",

    previousSelectedSlotNoFilter: null,
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,

}

export default function reducer(state = initialState, action) {
    let duplicateState = null

    switch (action.type) {

        case ORDER_STATISTICS_TABLE_READY:
            return Object.assign({},state,{isOrderStatisticsTableReady:action.payload})

        
        case DATE_FILTER_STATE:
            duplicateState =Object.assign({},state)
            duplicateState.previousStartDateState=action.payload.start_date
            duplicateState.previousEndDateState=action.payload.end_date
            return Object.assign({},state,duplicateState)

        case SLOT_NO_FILTER_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousSelectedSlotNoFilter = action.payload
            return Object.assign({},state,duplicateState)

        case SEARCH_TEXT_STATE:
            return Object.assign({},state,{previousSearchText:action.payload})

        case ROWS_PER_PAGE_STATE:
            return Object.assign({},state,{previousRowsPerPageValue:action.payload})
        
        case PAGINATION_STATE:
            duplicateState = Object.assign({}, state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case PUSH_ORDER_STATISTICS_VALUE:
            return Object.assign({}, state, { pushOrderStatisticsDetails: action.payload })

        
        default:
            return state
    }
}

export function orderStatisticsTableReady(data){
    return{
        type: ORDER_STATISTICS_TABLE_READY,
        payload: data
    }
}



export function slotNoFilterSelected(slot_no){
    return{
        type:SLOT_NO_FILTER_STATE,
        payload:slot_no
    }
}

export function dateFilterSelected(date){
    return{
        type:DATE_FILTER_STATE,
        payload:date
    }
}


export function selectedSearchTextUpdate(text) {
    return {
        type: SEARCH_TEXT_STATE,
        payload: text
    }
}

export function rowsPerPageUpdate(rowsPerPage) {
    return {
        type: ROWS_PER_PAGE_STATE,
        payload: rowsPerPage
    }
}

export function paginationUpdate(pageNo) {
    return {
        type: PAGINATION_STATE,
        payload: pageNo
    }
}

export function pushOrderStatisticsUpdate(value){
    return{
        type: PUSH_ORDER_STATISTICS_VALUE,
        payload:value
    }
}


// WEBPACK FOOTER //
// ./src/modules/OrdersTable/redux/order_statistics.js